import {
  DeleteOutlined,
  PlusOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import { t } from '@hefe/i18n';
import {
  BasketballPracticeTimesScheduleOverviewTeam,
  Gym,
  PracticeTimesScheduleEntry,
} from '@hefe/models';
import { isColorDark } from '@hefe/ui';
import { Button, Popconfirm, Space, Spin, Tooltip, Typography } from 'antd';
import styles from './practice-times-schedule-overview-time.module.scss';

interface PracticeTimesScheduleOverviewTimeProps {
  team: BasketballPracticeTimesScheduleOverviewTeam;
  time: PracticeTimesScheduleEntry;
  gyms: Gym[];
  dayOfWeek: number;
  scheduleId: number;
  disableEditing?: boolean;

  onDelete?: (time: PracticeTimesScheduleEntry) => void;
  isDeleting?: boolean;

  onOpenSettings?: (
    teamId: number,
    practiceTime: PracticeTimesScheduleEntry | undefined,
    dayOfWeek: number
  ) => void;
}

export default function PracticeTimesScheduleOverviewTime(
  props: PracticeTimesScheduleOverviewTimeProps
) {
  const {
    team,
    time,
    gyms,
    disableEditing,
    onDelete,
    isDeleting = false,
    onOpenSettings,
  } = props;

  let gymColor = time?.gym?.color;

  if (!gymColor) {
    gymColor = gyms?.find((gym) => gym.id === time.gym?.id)?.color;
  }

  const textColor = isColorDark(gymColor ?? '#ffffff') ? 'white' : 'black';

  const background = `linear-gradient(to right, ${gymColor} 50%, ${gymColor}${
    time?.split_location ? '80' : ''
  } 50%)`;

  const openPracticeTimeSettings = (
    teamId: number,
    practiceTime: PracticeTimesScheduleEntry | undefined
  ) => {
    if (isDeleting) {
      return;
    }

    onOpenSettings?.(teamId, practiceTime, props.dayOfWeek);
  };

  const deleteTime = () => {
    onDelete?.(time);
  };

  return (
    <Tooltip
      title={
        <Space>
          <Space direction="vertical">
            <Typography.Text style={{ color: 'white' }}>
              {time?.gym?.name}
            </Typography.Text>

            {(time?.basketball_teams ?? []).length > 1 && (
              <Typography.Text style={{ color: 'white' }}>
                {time?.basketball_teams?.map((team) => team.name).join(', ')}
              </Typography.Text>
            )}
          </Space>

          {!disableEditing && (
            <>
              {onOpenSettings && (
                <Button
                  onClick={() => openPracticeTimeSettings(team.id, undefined)}
                  size="small"
                  icon={<PlusOutlined />}
                />
              )}

              {onDelete && (
                <Popconfirm title={t('delete') + '?'} onConfirm={deleteTime}>
                  <Button
                    size="small"
                    icon={<DeleteOutlined />}
                    loading={isDeleting}
                  />
                </Popconfirm>
              )}
            </>
          )}
        </Space>
      }
      key={time.id}
      arrow={false}
    >
      <div
        onClick={() => {
          if (!disableEditing) {
            openPracticeTimeSettings(team.id, time);
          }
        }}
        key={time.id}
        className={styles['time']}
        style={{
          backgroundImage: background,
          backgroundSize: '10px 100%',
          color: textColor,
          cursor: !disableEditing ? 'pointer' : 'default',
        }}
      >
        {isDeleting ? (
          <Spin />
        ) : (
          <Space>
            {`${time.time} - ${time.end}`}

            {(time?.basketball_teams ?? []).length > 1 && (
              <UsergroupAddOutlined />
            )}
          </Space>
        )}
      </div>
    </Tooltip>
  );
}
